import { ArrowRight, CheckCircle2, TrendingDown, ChevronDown } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  const scrollToContact = () => {
    navigate('/offerte-anfordern');
  };

  const scrollDown = () => {
    window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
  };

  return (
    <section className="relative pt-24 md:pt-32 pb-24 min-h-[700px] bg-gradient-to-br from-slate-50 via-white to-slate-50 overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-slate-500/5 animate-gradient"></div>
        <img
          src="/umzugsunternehmen-schweiz-deutschland.jpeg"
          alt="Professionelles Umzugsunternehmen transportiert Möbel von der Schweiz nach Deutschland mit modernem Umzugswagen"
          title="Umzug Schweiz Deutschland - Professioneller Umzugsservice"
          className="w-full h-full object-cover opacity-10"
          fetchpriority="high"
          loading="eager"
        />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-green-50 text-green-700 px-4 py-2 rounded-full mb-6 border border-green-200 animate-fade-in hover:scale-105 transition-transform duration-300">
            <CheckCircle2 className="w-4 h-4" />
            <span className="text-sm font-semibold">+2000 erfolgreiche Umzüge nach Deutschland</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6 leading-tight animate-fade-in-delay">
            Umzug nach Deutschland
            <span className="block text-slate-700 text-4xl md:text-5xl mt-2">
              Ihre Umzugsfirma für Umzug Schweiz Deutschland
            </span>
          </h1>

          <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto leading-relaxed animate-fade-in-delay-2">
            Professionelle Umzugsfirma nach Deutschland mit <Link to="/komplettumzug" className="text-slate-900 font-semibold hover:underline">Komplettservice</Link>: <Link to="/zollabwicklung" className="text-slate-900 font-semibold hover:underline">Zollabwicklung</Link>, Transport & Montage.
            Auswandern nach Deutschland leicht gemacht – wir übernehmen alles von der Planung bis zur Schlüsselübergabe.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 mb-12 animate-fade-in-delay-2">
            <button
              onClick={scrollToContact}
              className="group bg-slate-800 hover:bg-slate-900 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105 flex items-center space-x-2 text-lg"
            >
              <span>Jetzt kostenloses Angebot anfordern</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              href="tel:0800700100"
              className="bg-white hover:bg-slate-50 text-slate-800 px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-md hover:shadow-xl hover:scale-105 border-2 border-slate-800"
            >
              0800 700 100 (Gratis)
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto mb-16">
            <Link to="/express-umzuege" className="bg-white rounded-xl p-6 shadow-md border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 animate-fade-in-delay-2 block">
              <div className="text-3xl font-bold text-slate-800 mb-1">24-48h</div>
              <div className="text-slate-600 text-sm">Express-Umzug möglich</div>
            </Link>
            <Link to="/zollabwicklung" className="bg-white rounded-xl p-6 shadow-md border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 animate-fade-in-delay-2 block">
              <div className="text-3xl font-bold text-slate-800 mb-1">100%</div>
              <div className="text-slate-600 text-sm">Zollabwicklung inklusive</div>
            </Link>
            <Link to="/preise" className="bg-white rounded-xl p-6 shadow-md border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 animate-fade-in-delay-2 block">
              <div className="flex items-center justify-center space-x-2 mb-1">
                <TrendingDown className="w-6 h-6 text-green-600" />
                <div className="text-3xl font-bold text-slate-800">Fixpreis</div>
              </div>
              <div className="text-slate-600 text-sm">Transparente Kosten</div>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
        <button
          onClick={scrollDown}
          className="animate-bounce bg-white hover:bg-slate-50 text-slate-800 p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-slate-200"
          aria-label="Scroll down"
        >
          <ChevronDown className="w-6 h-6" />
        </button>
      </div>
    </section>
  );
}
